export const types = {
  close: 1,
  confirm: 2,
  cancel: 3,
};

export const ORDER_TYPE = [
  {
    id: 1,
    label: 'Retirada no balcão',
    name: 'takeaway',
    enableName: 'orderTakeAwayEnabled',
    tag: 'No balcão',
  },
  {
    id: 2,
    label: 'Delivery (Outdoor)',
    name: 'delivery',
    enableName: 'orderDeliveryEnabled',
    tag: 'Delivery',
  },
  {
    id: 3,
    label: 'Servir na mesa',
    name: 'shortDelivery',
    enableName: 'orderShortDeliveryEnabled',
    tag: 'Na mesa',
  },
  {
    id: 4,
    label: 'Voucher',
    name: 'voucher',
    enableName: 'orderVoucherEnabled',
    tag: 'Voucher',
  },
  {
    id: 5,
    label: 'Comanda',
    name: 'check',
    enableName: 'orderCheckEnabled',
    tag: 'Check',
  },
  {
    id: 6,
    label: 'Na comanda',
    name: 'inStore',
    enableName: 'orderInStoreEnabled',
    tag: 'Na Comanda',
  },
  {
    id: 7,
    label: 'Mesa',
    name: 'shortTakeAway',
    enableName: 'orderShortTakeAwayEnabled',
    tag: 'Mesa',
  },
  {
    id: 8,
    label: 'Loja',
    name: 'fourPay',
    enableName: 'fourPayEnabled',
    tag: 'Loja',
  },
];

export const MENU_ACTIONS_TYPE = [
  {
    type: 'edit',
    label: 'Gerenciar Produtos',
  },
  {
    type: 'duplicate',
    label: 'Duplicar Cardápio',
  },
  {
    type: 'edit-rules',
    label: 'Editar Regras',
  },
  {
    type: 'delete',
    label: 'Excluir',
  },
];

export const PRODUCT_ACTIONS_TYPE = [
  {
    type: 'edit',
    label: 'editar',
  },
  {
    type: 'delete',
    label: 'excluir',
  },
];

export const VARIATIONS_ACTIONS_TYPE = [
  {
    type: 'edit',
    label: 'editar',
  },
  {
    type: 'delete',
    label: 'excluir',
  },
];

export const VARIATIONS_OPTIONS_ACTIONS_TYPE = [
  {
    type: 'edit',
    label: 'editar',
  },
  {
    type: 'delete',
    label: 'excluir',
  },
];

export const GET_LIMIT = 1000;

export const NEW_MENU = {
  id: 0,
  name: '',
  marketplaces: [],
  takeaway: false,
  delivery: false,
  shortDelivery: false,
  voucher: false,
};

export const DELIVERY = {
  id: 2,
  label: 'Delivery',
  name: 'orderDeliveryEnabled',
  checked: true,
};

export const initialState = {
  id: 0,
  variationName: '',
  tab1View: '',
  tab2View: 'hidden',
  optionsList: [
    {
      id: `variation-${new Date().getTime()}`,
      name: '',
      originalPrice: '',
      desc: '',
    },
  ],
  optionSelected: 'unic',
  max: 0,
  min: 0,
  calcVariationSelected: 'soma',
  optionRequired: false,
  minMaxValidation: '',
  variationDuplicatedValidation: true,
  inputVariationNameValidate: true,
  inputsErrors: [],
};

export const NEW_PRODUCT = {
  vegan: false,
  glutenFree: false,
  lactoseFree: false,
  vegetarian: false,
  organic: false,
  sugarFree: false,
  originalPrice: 0,
  unit: '',
  sortOrder: 0,
  categories: [
    {
      name: '',
      type: 0,
      merchantId: '',
      id: '',
    },
  ],
  image: {
    imageUrl: '',
    imageBase64: '',
    extension: '',
    contentType: '',
  },
  sku: '',
  barcode: '',
  merchantId: '',
  desc: '',
  status: 0,
  name: '',
  productVariations: [],
};

export const SELECT_SCREEN = {
  informationScreen: 1,
  categoryScreen: 2,
  variationScreen: 3,
};

export const SERVICE_TYPES = [
  {
    id: 1,
    label: 'Delivery',
    value: 'delivery',
    enableName: 'orderDeliveryEnabled',
    tag: 'Delivery',
  },
  {
    id: 2,
    label: 'Retirada no balcão',
    value: 'takeaway',
    enableName: 'orderTakeAwayEnabled',
    tag: 'No balcão',
  },
  {
    id: 3,
    label: 'Servir na mesa',
    value: 'shortDelivery',
    enableName: 'orderShortDeliveryEnabled',
    tag: 'Na mesa',
  },
  {
    id: 4,
    label: 'Voucher',
    value: 'voucher',
    enableName: 'orderVoucherEnabled',
    tag: 'Voucher',
  },
  {
    id: 5,
    label: 'Na comanda',
    value: 'inStore',
    enableName: 'orderInStoreEnabled',
    tag: 'Na Comanda',
  },
  {
    id: 6,
    label: 'Dine In',
    value: 'dineIn',
    enableName: 'orderDineInEnabled',
    tag: 'Dine In',
  },
];

export const SELECT_SERVICES_UHUU_LIST = [
  {
    label: 'No local',
    options: [
      {
        id: 4,
        label: 'Voucher',
        value: 'voucher',
        enableName: 'orderVoucherEnabled',
        tag: 'Voucher',
      },
    ],
  },
];

export const SELECT_SERVICES_LIST = [
  {
    options: [
      {
        id: 1,
        label: 'Delivery',
        value: 'delivery',
        enableName: 'orderDeliveryEnabled',
        tag: 'Delivery',
      },
    ],
  },
  {
    label: 'No local',
    options: [
      {
        id: 2,
        label: 'Retirada no balcão',
        value: 'takeaway',
        enableName: 'orderTakeAwayEnabled',
        tag: 'No balcão',
      },
      {
        id: 3,
        label: 'Servir na mesa',
        value: 'shortDelivery',
        enableName: 'orderShortDeliveryEnabled',
        tag: 'Na mesa',
      },
      {
        id: 4,
        label: 'Voucher',
        value: 'voucher',
        enableName: 'orderVoucherEnabled',
        tag: 'Voucher',
      },
      {
        id: 5,
        label: 'Na comanda',
        value: 'inStore',
        enableName: 'orderInStoreEnabled',
        tag: 'Na Comanda',
      },
      {
        id: 6,
        label: 'Dine In',
        value: 'dineIn',
        enableName: 'orderDineInEnabled',
        tag: 'Dine In',
      },
    ],
  },
];

export const UHUU_MKTPC_ID = 8;

export const NEW_MENU_STORAGE_KEY = 'persist_menu';

export const SALE_TYPES = {
  specificMenu: 1,
  generalMenu: 2,
  defaultMenu: 3,
};

export const ZINDEX = {
  MODAL: 1000,
  TOP: 900,
};

export const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    borderRadius: '5px',
    width: '90%',
    maxWidth: '920px',
    height: '550px',
    maxHeight: '800px',
    padding: '0',
    boxShadow: '0 0 15px 0 rgba(0, 0, 0, .4)',
    border: 'none',
    position: 'absolute',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.41)',
    zIndex: ZINDEX.MODAL,
  },
};

export const MAX_EXHIBITIONS = 1;

export const UHUU_GENERAL_TICKET_TYPE = 'id_inteira';

export const FILE_EXTENSIONS_WHITELIST = ['.png', '.jpeg', '.jpg'];

export const UPLOAD_FILE_MAX_SIZE = 2000000;

export const PRODUCT_ADDONS_TYPE = {
  PRODUCTS: 2,
  VARIATIONS: 1,
};

/* ADDON PRODUCTS */
export const PRODUCT_ADDONS = {
  SELECTED_PRODUCTS: 1,
  SELECTED_GLOBAL_VARIATIONS: 2,
};

export const VARIATION_PRICE_TYPES = {
  totalSum: 0,
  averagePrice: 1,
};

export const VARIATION_DRAG_DROP_COLUMNS = {
  PRODUCT_VARIATIONS: 'variations',
  GLOBAL_VARIATIONS: 'global-variations',
};
export const VARIATION_SELECTION_OPTIONS = {
  onlyOneOption: 0,
  noLimitation: 1,
  limitMinAndMax: 2,
};

export const PRODUCT_CREATION_VARIATION_TYPE = {
  global: 0,
  product: 1,
};

export const PRODUCT_VARIATION_ID_PREFIX = 'product-';

export const MAX_SELECTED_TAGS = 3;

export const VARIATION_INITIAL_ERROR_STATE = {
  name: { isInvalid: false },
  title: { isInvalid: false },
  atLeastOneVariationOption: { isInvalid: false },
  min: { isInvalid: false },
  max: { isInvalid: false },
  variationOptionsErrors: {
    name: { isInvalid: false },
    originalPrice: { isInvalid: false },
  },
};

export const VARIATION_OPTION_INITIAL_FORM_STATE = {
  sku: '',
  name: '',
  desc: '',
  originalPrice: '0,00',
};

export const VARIATION_MODAL_INITIAL_STATE = {
  name: '',
  title: '',
  selectionOption: VARIATION_SELECTION_OPTIONS.onlyOneOption,
  min: '',
  max: '',
  priceType: VARIATION_PRICE_TYPES.totalSum,
  priceTypeBlocked: true,
  minMaxDisabled: true,
  options: [],
  currEditingOptionId: '',
  form: { ...VARIATION_OPTION_INITIAL_FORM_STATE },
  errors: { ...VARIATION_INITIAL_ERROR_STATE },
  errorMessage: '',
};

export const CRUD_TYPES = {
  EDIT: 'edit',
  SAVE: 'save',
  DELETE: 'delete',
  SORT_ORDER: 'sortOrder',
};

export const HTTP_STATUS_CODE = {
  CREATED: 201,
  NO_CONTENT: 204,
  OK: 200,
};

export const ENTITIES = {
  CATEGORY: 'CATEGORY',
  PRODUCT: 'PRODUCT',
};

export const PRODUCT_CORE_ACTIONS = {
  EXPORT: 'export',
  DELETE: 'delete',
  CHANGE_STATUS: 'changeStatus',
  EDIT: 'edit',
};

export const PRODUCT_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
};

export const VARIATION_ERROR_MESSAGE = {
  default: 'Preencha os campos sinalizados para continuar',
  atLeastOneVariationOption: 'Cadastre pelo menos uma opção da variação',
  minGreaterThanMax: 'A qtd. mínima não pode ser maior que a qtd. máxima',
  maxGreaterThanZero: 'A quantidade máxima deve ser maior que 0',
};

export const SCROLL_TO_TYPE = {
  product: 'product',
  menu: 'menu',
};

export const PRODUCT_ELEMENT_ID_PREFIX = 'product_';

export const MENU_ELEMENT_ID_PREFIX = 'menu-list-';

export const PATHS = {
  createMenuUhuu: '/admin/menu/create_menu_uhuu',
  createProduct: '/admin/products/create_product/',
  editProduct: '/admin/products/create_product/:id',
  menu: '/admin/menu',
  products: '/admin/products',
  selectProducts: '/admin/menu/select_products',
  globalVariations: '/admin/variations',
};



// WEBPACK FOOTER //
// ./src/helpers/constants.js